import { ComponentProps, FC } from 'react'

import { twMerge } from '~/lib/utils'

type InputErrorProps = { children: React.ReactNode } & ComponentProps<'p'>

export const InputError: FC<InputErrorProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <p className={twMerge('text-alert', className)} {...props}>
      {children}
    </p>
  )
}
